"use strict";
// (C) 2019-2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.BearExecutionResult = void 0;
var tslib_1 = require("tslib");
var sdk_backend_base_1 = require("@gooddata/sdk-backend-base");
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var spark_md5_1 = tslib_1.__importDefault(require("spark-md5"));
var errorHandling_1 = require("../../../utils/errorHandling");
var ExecutionConverter_1 = require("../../../convertors/toBackend/afm/ExecutionConverter");
var ExecutionResultConverter_1 = require("../../../convertors/fromBackend/ExecutionResultConverter");
var result_1 = require("../../../convertors/fromBackend/afm/result");
var dateFormatter_1 = require("../../../convertors/dateFormatting/dateFormatter");
var BearExecutionResult = /** @class */ (function () {
    function BearExecutionResult(authApiCall, definition, execFactory, execResponse) {
        var _this = this;
        this.authApiCall = authApiCall;
        this.definition = definition;
        this.execFactory = execFactory;
        this.execResponse = execResponse;
        this.asDataView = function (promisedRes) {
            return promisedRes.then(function (res) {
                if (!res) {
                    // TODO: SDK8: investigate when can this actually happen; perhaps end of data during paging?
                    //  perhaps legitimate NoDataCase?
                    throw new sdk_backend_spi_1.UnexpectedError("Server returned no data");
                }
                if (isEmptyDataResult(res)) {
                    throw new sdk_backend_spi_1.NoDataError("The execution resulted in no data to display.", new BearDataView(_this, res));
                }
                return new BearDataView(_this, res);
            });
        };
        this.dimensions = ExecutionResultConverter_1.convertDimensions(execResponse.dimensions);
        this._fingerprint = spark_md5_1.default.hash(execResponse.links.executionResult);
    }
    BearExecutionResult.prototype.readAll = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.asDataView(this.authApiCall(function (sdk) { return sdk.execution.getExecutionResult(_this.execResponse.links.executionResult); }, errorHandling_1.convertExecutionApiError))];
            });
        });
    };
    BearExecutionResult.prototype.readWindow = function (offset, size) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var saneOffset, saneSize;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                saneOffset = sanitizeOffset(offset);
                saneSize = sanitizeSize(size);
                return [2 /*return*/, this.asDataView(this.authApiCall(function (sdk) {
                        return sdk.execution.getPartialExecutionResult(_this.execResponse.links.executionResult, saneSize, saneOffset);
                    }, errorHandling_1.convertExecutionApiError))];
            });
        });
    };
    BearExecutionResult.prototype.transform = function () {
        return this.execFactory.forDefinition(this.definition);
    };
    BearExecutionResult.prototype.export = function (options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var optionsForBackend;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                optionsForBackend = {
                    format: options.format,
                    mergeHeaders: options.mergeHeaders,
                    title: options.title,
                    showFilters: options.showFilters,
                };
                if (options.showFilters) {
                    optionsForBackend.afm = ExecutionConverter_1.toAfmExecution(this.definition).execution.afm;
                }
                return [2 /*return*/, this.authApiCall(function (sdk) {
                        return sdk.report.exportResult(_this.definition.workspace, _this.execResponse.links.executionResult, optionsForBackend);
                    })];
            });
        });
    };
    BearExecutionResult.prototype.equals = function (other) {
        return this.fingerprint() === other.fingerprint();
    };
    BearExecutionResult.prototype.fingerprint = function () {
        return this._fingerprint;
    };
    return BearExecutionResult;
}());
exports.BearExecutionResult = BearExecutionResult;
var BEAR_PAGE_SIZE_LIMIT = 1000;
function sanitizeOffset(offset) {
    return offset.map(function (offsetItem) {
        if (offsetItem === void 0) { offsetItem = 0; }
        return offsetItem;
    });
}
function sanitizeSize(size) {
    return size.map(function (sizeInDim) {
        if (sizeInDim === void 0) { sizeInDim = BEAR_PAGE_SIZE_LIMIT; }
        if (sizeInDim > BEAR_PAGE_SIZE_LIMIT) {
            // eslint-disable-next-line no-console
            console.warn("The maximum limit per page is " + BEAR_PAGE_SIZE_LIMIT);
            return BEAR_PAGE_SIZE_LIMIT;
        }
        return sizeInDim;
    });
}
var BearDataView = /** @class */ (function () {
    function BearDataView(result, dataResult) {
        var _a, _b;
        this.result = result;
        this.definition = result.definition;
        this.data = dataResult.data;
        this.headerItems = dataResult.headerItems ? dataResult.headerItems : [];
        this.totals = dataResult.totals;
        this.totalCount = dataResult.paging.total;
        this.count = dataResult.paging.count;
        this.offset = dataResult.paging.offset;
        this.warnings = (_b = (_a = dataResult.warnings) === null || _a === void 0 ? void 0 : _a.map(ExecutionResultConverter_1.convertWarning)) !== null && _b !== void 0 ? _b : [];
        this._fingerprint = result.fingerprint() + "/" + this.offset.join(",") + "-" + this.count.join(",");
        this.headerItems = sdk_backend_base_1.transformResultHeaders(this.headerItems, result_1.createResultHeaderTransformer(dateFormatter_1.findDateAttributeUris(result.dimensions)), this.definition.postProcessing);
    }
    BearDataView.prototype.fingerprint = function () {
        return this._fingerprint;
    };
    BearDataView.prototype.equals = function (other) {
        return this.fingerprint() === other.fingerprint();
    };
    return BearDataView;
}());
//
//
//
function hasEmptyData(result) {
    return result.data.length === 0;
}
function hasMissingHeaderItems(result) {
    return !result.headerItems;
}
function isEmptyDataResult(result) {
    return hasEmptyData(result) && hasMissingHeaderItems(result);
}
//# sourceMappingURL=executionResult.js.map